import React, { Component } from 'react';

export default class Status extends Component {
  render() {
    let icon = null;
    if (this.props.option == 1) {
      icon = (
        <span className="badge badge-rounded badge-success badge-lg">
          <i className="fa fa-check"></i>
        </span>
      );
    } else {
      icon = (
        <span className="badge badge-rounded badge-danger badge-lg">
          <i className="fa fa-close"></i>
        </span>
      );
    }
    return (
      <span>
        {icon}
      </span>
    );
  }
};



// WEBPACK FOOTER //
// ./src/common/Status/index.js